import dt from 'datatables.net';
import dtBootstrap from 'datatables.net-bs4';
import dtFixedColumns from 'datatables.net-fixedcolumns'
//import selectionAccesses from "./datatables/selectionAccesses";
//import companies from "./datatables/companies"
//import users from "./datatables/users";



export default () => {
    // initialize datatables
    dt(window, $);
    // dtBootstrap(window, $);
    dtFixedColumns(window, $);

    //const tableUserList = users();
    //const tableCompanyList = companies();
    //const tableSelectionAccesses = selectionAccesses();

    //let selectedTable = tableUserList;

    $('#user-list-mobile').on('click', (ev) => {
        $('.user-list').click();
    });
    $('#company-list-mobile').on('click', (ev) => {
        $('.company-list').click();
    });
    $('#selection-accesses-mobile').on('click', (ev) => {
        $('.selection-access').click();
    });

    $('#mobile-select-drop').on('click', (ev) => {
        if(ev.target.parentElement.className == 'dropdown-item'){
            $('#default-selected')[0].innerHTML = ev.target.parentElement.innerHTML;
        }else if(ev.target.className == 'dropdown-item'){
            $('#default-selected')[0].innerHTML = ev.target.innerHTML;
        }        
    })

    $('#searchInput').on('keyup', (ev) => {
        
        const search = ev.target.value;
        
        tableUserList.search( search ).draw();
        tableCompanyList.search( search ).draw();
        tableSelectionAccesses.search( search ).draw();
        
        const badgeUL = tableUserList.page.info().recordsDisplay;
        const badgeCL = tableCompanyList.page.info().recordsDisplay;
        const badgeSA = tableSelectionAccesses.page.info().recordsDisplay;

        let arr = [badgeUL, badgeCL, badgeSA];
        let i = arr.indexOf(Math.max(...arr));
        if(i === 0)$('.user-list').click();
        if(i === 1)$('.company-list').click();
        if(i === 2)$('.selection-access').click();

        if(badgeUL && search)$('#badgeUS').html(`${badgeUL}`).show();
        else $('#badgeUS').hide();
        if(badgeCL && search)$('#badgeCL').html(`${badgeCL}`).show();
        else $('#badgeCL').hide(); 
        if(badgeSA && search)$('#badgeSA').html(`${badgeSA}`).show();
        else $('#badgeSA').hide();

        if(!badgeUL){
            $('#table_user_list_length').hide();
            $('#table_user_list_paginate').hide();
        }else{
            $('#table_user_list_length').show();
            $('#table_user_list_paginate').show();
        }
        
        if(!badgeCL){
            $('#table_company_list_length').hide();
            $('#table_company_list_paginate').hide();
        }else{
            $('#table_company_list_length').show();
            $('#table_company_list_paginate').show();
        }

        if(!badgeSA){
            $('#table_selection_accesses_length').hide();
            $('#table_selection_accesses_paginate').hide();
        }else{
            $('#table_selection_accesses_length').show();
            $('#table_selection_accesses_paginate').show();
        }

    });

    $('#searchInputMobile').on('keyup', (ev) => {        
        const search = ev.target.value;
        
        tableUserList.search( search ).draw();
        tableCompanyList.search( search ).draw();
        tableSelectionAccesses.search( search ).draw();
        
        const badgeUL = tableUserList.page.info().recordsDisplay;
        const badgeCL = tableCompanyList.page.info().recordsDisplay;
        const badgeSA = tableSelectionAccesses.page.info().recordsDisplay;

        let arr = [badgeUL, badgeCL, badgeSA];
        let i = arr.indexOf(Math.max(...arr));
        if(i === 0)$('#user-list-mobile').click();
        if(i === 1)$('#company-list-mobile').click();
        if(i === 2)$('#selection-accesses-mobile').click();

        if(badgeUL && search)$('.badgeUSm').html(`${badgeUL}`).show();
        else $('.badgeUSm').hide();
        if(badgeCL && search)$('.badgeCLm').html(`${badgeCL}`).show();
        else $('.badgeCLm').hide(); 
        if(badgeSA && search)$('.badgeSAm').html(`${badgeSA}`).show();
        else $('.badgeSAm').hide();
    });


}

const resizeTable = (table) => {
    const numColumns = table.columns()[0].length;
    const width = window.innerWidth;

    if (width <= 768){
        for ( var i=3 ; i<numColumns  ; i++ ) {
            table.column( i ).visible( false, false );            
        }

        table.columns.adjust().draw( false ); // adjust column sizing and redraw

    }else{

        for ( var i=3 ; i<numColumns  ; i++ ) {
            table.column( i ).visible( true, true );            
        }

        table.columns.adjust().draw( true ); 
    }
}